// extracted by mini-css-extract-plugin
module.exports = {"dark":"Logo_dark__0GBcl","left":"Logo_left__6tL39","right":"Logo_right__AJ8js","figure":"Logo_figure__b47b0","logo":"Logo_logo___yD0t","withText":"Logo_withText__J64ao"};